import React from 'react'

import styled from 'styled-components'

import KeyboardAccessible from 'components/KeyboardAccessible'
import SortIcon from 'components/Table/SortIcon'
import Tooltip from 'components/Tooltip'

import { color } from 'styles/colors'
import FilterIcon from './FilterIcon'

interface HeaderCell {
  title: string
  className?: string | undefined
  sortable?: boolean
  sortDirection?: string | null
  onSort?: () => void
  enableFilter?: boolean
  onClickFilterIcon?: () => void
  anyFilterSelected?: boolean
  tooltip?: string | null
}

const HeaderCell = ({
  title,
  className,
  sortable = false,
  sortDirection = null,
  onSort = () => {},
  enableFilter = false,
  anyFilterSelected = false,
  onClickFilterIcon = () => {},
  tooltip = null
}: HeaderCell) => {
  return (
    <S.Cell tabIndex={sortable ? 0 : -1} {...{ className }} onClick={onSort}>
      {tooltip != null
        ? <Tooltip title={tooltip} placement="top"><div>{title}</div></Tooltip>
        : <div>{title}</div>
      }

      {enableFilter && <FilterIcon onClickFilterIcon={onClickFilterIcon} anyFilterSelected={anyFilterSelected} /> }
      {sortable && <SortIcon sortDirection={sortDirection} />}
    </S.Cell>
  )
}

export default HeaderCell

const S = {
  Cell: styled(KeyboardAccessible).withConfig({
    shouldForwardProp: (prop) => !['tabIndex'].includes(prop)
  })<{ tabIndex: number }>`
    position: relative;
    display: flex;
    flex: 1;
    align-items: center;
    min-height: 50px;
    margin-right: 1px;
    padding-left: 15px;
    font-weight: bold;
    background: ${color('tableHeaderBackground')};
    cursor: ${({ tabIndex }) => tabIndex === 0 ? 'pointer' : 'default'};
    color: ${color('primaryText')};
  `
}
